import { ContactCard } from 'src/types';
import css from './contact-card.module.scss';
import Complaint from 'src/pages/complaint/complaint';
import React from 'react';
import ContactIcon from './contact-icons';
import { ComplaintEntityType } from 'src/constants/complaint-entity-type';

interface CardProps {
  blockId: string;
  cards: ContactCard[];
  blockTitle: string;
}

export default function ContactBlockView({ blockId, cards, blockTitle }: Readonly<CardProps>) {
  const wrapper = (
    complaint: JSX.Element,
    onMouseEnter: React.MouseEventHandler<HTMLDivElement> | undefined,
    onMouseLeave: React.MouseEventHandler<HTMLDivElement> | undefined
  ) => (
    <div className={css.card} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
      {complaint}
      <div className={css.contactWrapper}>{cards?.map((card) => <ContactView card={card} key={card.id} />)}</div>
    </div>
  );
  return (
    <Complaint
      key={blockId}
      entityId={blockId}
      targetTitle={`${blockTitle}`}
      entityType={ComplaintEntityType.CONTACTS_CARD}
      alignRight={true}
      wrapper={wrapper}
    />
  );
}

export function ContactView({ card }: Readonly<{ card: ContactCard }>) {
  return (
    <React.Fragment>
      {card.contacts.map((contact) => (
        <div className={css.contact} key={contact.id}>
          <div className={css.value}>
            <p>{contact.value}</p>
            <ContactIcon contact={contact} />
          </div>
          <p className={css.name}>
            {contact.name}
            <br />
            {card.title}
          </p>
        </div>
      ))}
    </React.Fragment>
  );
}
